import { Grid, Text, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form/lib/use-form';
import {
  BusinessFileNames,
  BusinessFileNamesReadable,
} from '../../../../enums/business-file-names';
import { BusinessTypes } from '../../../../enums/business-type';
import { UpdateMerchantOnboardingFormValues } from '../../../../type/update-merchant-onboarding-form-values.types';
import UpdateFileUpload from '../../../buttons/file-upload.button/update-file-upload.button';

interface UpdateUploadDocumentsProps {
  form: UseFormReturnType<UpdateMerchantOnboardingFormValues>;
  businessTypeId: BusinessTypes;
}
function UpdateUploadDocuments(props: UpdateUploadDocumentsProps) {
  const { form, businessTypeId } = props;

  const ChangeRequiredFiles = () => {
    if (businessTypeId === BusinessTypes.STARTER) {
      return (
        <>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.VALID_IDS_OF_SIGNATORY}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.VALID_IDS_OF_SIGNATORY}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.VALID_IDS_OF_SIGNATORY_BACK}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.VALID_IDS_OF_SIGNATORY_BACK}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.VALID_IDS_OF_SIGNATORY_SIGNATURE}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.VALID_IDS_OF_SIGNATORY_SIGNATURE}
            />
          </Grid.Col>

          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.BARANGAY_BUSINESS_PERMIT}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.BARANGAY_BUSINESS_PERMIT}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.BARANGAY_BUSINESS_PERMIT_BACK}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.BARANGAY_BUSINESS_PERMIT_BACK}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.BARANGAY_BUSINESS_PERMIT_SIGNATURE}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.BARANGAY_BUSINESS_PERMIT_SIGNATURE}
            />
          </Grid.Col>

          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.STORE_PHOTO_WITH_STORE_NAME}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.STORE_PHOTO_WITH_STORE_NAME}
            />
          </Grid.Col>
        </>
      );
    } else if (businessTypeId === BusinessTypes.SOLE_PROPRIETOR) {
      return (
        <>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.VALID_IDS_OF_SIGNATORY}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.VALID_IDS_OF_SIGNATORY}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.VALID_IDS_OF_SIGNATORY_BACK}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.VALID_IDS_OF_SIGNATORY_BACK}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.VALID_IDS_OF_SIGNATORY_SIGNATURE}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.VALID_IDS_OF_SIGNATORY_SIGNATURE}
            />
          </Grid.Col>

          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.MAYORS_OR_BUSINESS_PERMIT}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.MAYORS_OR_BUSINESS_PERMIT}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.MAYORS_OR_BUSINESS_PERMIT_BACK}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.MAYORS_OR_BUSINESS_PERMIT_BACK}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.MAYORS_OR_BUSINESS_PERMIT_SIGNATURE}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.MAYORS_OR_BUSINESS_PERMIT_SIGNATURE}
            />
          </Grid.Col>

          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.BIR_CERTIFICATE_2303}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.BIR_CERTIFICATE_2303}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.BIR_CERTIFICATE_2303_BACK}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.BIR_CERTIFICATE_2303_BACK}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.BIR_CERTIFICATE_2303_SIGNATURE}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.BIR_CERTIFICATE_2303_SIGNATURE}
            />
          </Grid.Col>
        </>
      );
    } else if (
      businessTypeId === BusinessTypes.PARTNERSHIP ||
      businessTypeId === BusinessTypes.CORPORATION
    ) {
      return (
        <>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.VALID_IDS_OF_SIGNATORY}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.VALID_IDS_OF_SIGNATORY}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.VALID_IDS_OF_SIGNATORY_BACK}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.VALID_IDS_OF_SIGNATORY_BACK}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.VALID_IDS_OF_SIGNATORY_SIGNATURE}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.VALID_IDS_OF_SIGNATORY_SIGNATURE}
            />
          </Grid.Col>

          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.MAYORS_OR_BUSINESS_PERMIT}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.MAYORS_OR_BUSINESS_PERMIT}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.MAYORS_OR_BUSINESS_PERMIT_BACK}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.MAYORS_OR_BUSINESS_PERMIT_BACK}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.MAYORS_OR_BUSINESS_PERMIT_SIGNATURE}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.MAYORS_OR_BUSINESS_PERMIT_SIGNATURE}
            />
          </Grid.Col>

          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.BIR_CERTIFICATE_2303}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.BIR_CERTIFICATE_2303}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.BIR_CERTIFICATE_2303_BACK}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.BIR_CERTIFICATE_2303_BACK}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.BIR_CERTIFICATE_2303_SIGNATURE}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.BIR_CERTIFICATE_2303_SIGNATURE}
            />
          </Grid.Col>

          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.SEC_CERTIFICATE}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.SEC_CERTIFICATE}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.SEC_CERTIFICATE_BACK}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.SEC_CERTIFICATE_BACK}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.SEC_CERTIFICATE_SIGNATURE}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.SEC_CERTIFICATE_SIGNATURE}
            />
          </Grid.Col>

          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.AOI_AND_BY_LAWS}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.AOI_AND_BY_LAWS}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.AOI_AND_BY_LAWS_BACK}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.AOI_AND_BY_LAWS_BACK}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.AOI_AND_BY_LAWS_SIGNATURE}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.AOI_AND_BY_LAWS_SIGNATURE}
            />
          </Grid.Col>

          {businessTypeId === BusinessTypes.CORPORATION && (
            <>
              <Grid.Col xs={12} md={6}>
                <Text style={{ fontSize: 14 }}>
                  {BusinessFileNamesReadable.GIS}
                </Text>
                <UpdateFileUpload form={form} value={BusinessFileNames.GIS} />
              </Grid.Col>
              <Grid.Col xs={12} md={6}>
                <Text style={{ fontSize: 14 }}>
                  {BusinessFileNamesReadable.GIS_BACK}
                </Text>
                <UpdateFileUpload
                  form={form}
                  value={BusinessFileNames.GIS_BACK}
                />
              </Grid.Col>
              <Grid.Col xs={12} md={6}>
                <Text style={{ fontSize: 14 }}>
                  {BusinessFileNamesReadable.GIS_SIGNATURE}
                </Text>
                <UpdateFileUpload
                  form={form}
                  value={BusinessFileNames.GIS_SIGNATURE}
                />
              </Grid.Col>
            </>
          )}
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.SECRETARYS_CERTIFICATE}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.SECRETARYS_CERTIFICATE}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.SECRETARYS_CERTIFICATE_BACK}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.SECRETARYS_CERTIFICATE_BACK}
            />
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Text style={{ fontSize: 14 }}>
              {BusinessFileNamesReadable.SECRETARYS_CERTIFICATE_SIGNATURE}
            </Text>
            <UpdateFileUpload
              form={form}
              value={BusinessFileNames.SECRETARYS_CERTIFICATE_SIGNATURE}
            />
          </Grid.Col>
        </>
      );
    }
  };

  return (
    <>
      <Grid>
        <Grid.Col>
          <Title order={4}>Upload Documents</Title>
        </Grid.Col>
        {ChangeRequiredFiles()}
      </Grid>
    </>
  );
}
export default UpdateUploadDocuments;
